import React from 'react';

import {
  BASE_FILTER_FORM_PROP_NAMES,
  BaseFilterFormProps,
  FilterStyle,
} from 'search/filters/base/FilterFormConstants';
import OperatorDropdown from 'search/filters/base/OperatorDropdown';
import SecondaryFilterFormSkeleton from 'search/filters/base/SecondaryFilterFormSkeleton';
import {Operator, AaSequenceStructureFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

interface OperatorOnlyDropdownFilterFormProps extends BaseFilterFormProps {
  filter: AaSequenceStructureFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: AaSequenceStructureFilter) => void;
  onRemove: () => void;
  operators: Array<Operator>;
}
export default function OperatorOnlyDropdownFilterForm(
  props: OperatorOnlyDropdownFilterFormProps
): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const operatorDropdown = (
    <OperatorDropdown
      buttonSize={props.buttonSize}
      onChangeOperator={(value) => {
        props.onChangeFilter({...props.filter, operator: value});
      }}
      operators={props.operators}
      selectedOperator={props.filter.operator}
    />
  );
  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[operatorDropdown]]}
      onRemove={props.onRemove}
    />
  );
}
